import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import type { FontVariant } from './fontVariant';

export const TriageErrorFix = ({
  fontVariant = 'font16',
  steps,
}: {
  fontVariant?: FontVariant;
  steps: string[];
}) => (
  <Box
    component='ol'
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      m: 0,
      pl: '20px',
    }}
  >
    {steps.map(step => (
      <li key={step}>
        <Typography variant={fontVariant}>{step}</Typography>
      </li>
    ))}
  </Box>
);
